import React from 'react';

import SpotlioIcon from '../Icon';
import Divider from "../Divider";
import Typography from "../Typography";
import Avatar from '../Avatar';

import { getUserSettings, setUserSettings, getSystemSettings } from '../../utils/SettingsRetriever';
import IntlMessage from '../../LocaleEngine';

import './index.scss';

export default class CurrencySelector extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedCurrency: getUserSettings().currencies.selected,
            currenciesList: getSystemSettings().app.currency,
            displayModal: false
        };
    }

    componentDidMount() {
        document.addEventListener('click', this.handleClick, false);
    }
    
    componentWillUnmount() {
        document.removeEventListener('click', this.handleClick, false);
    }

    handleUpdateSystemSettings = () => {
        const UserSettings = getUserSettings();
        setUserSettings({
            ...UserSettings,
            currencies: {
                ...UserSettings.currencies,
                selected: this.state.selectedCurrency
            }
        });
        this.setState({...this.state}, () => {    
            // window.location.reload();
            const event = new CustomEvent("changeCurrency");
            document.dispatchEvent(event);
        });
    }

    handleSelectCurrency = (index) => {
        this.setState({...this.state, selectedCurrency: index, displayModal: false}, () => this.handleUpdateSystemSettings());
    }

    handleRenderCurrenciesList = () => {
        const currentlySelectedCurrencyIndex = this.state.selectedCurrency;
        let favoriteCurrencies = [];
        let currenciesList = [];
        this.state.currenciesList.list.forEach((val, idx) => {
            if (idx === currentlySelectedCurrencyIndex) val.selected = true;
            else val.selected = false;
            val.idx = idx;
            if (this.state.currenciesList.preferred && this.state.currenciesList.preferred.indexOf(val.base) >= 0) {
                favoriteCurrencies.push(val);
            } else {
                currenciesList.push(val);
            }
        });
        
        const currencyComponent = (val, idx) => (
            <React.Fragment>
                <div key={idx} className={"CurrencyItem " + (val.selected ? "Selected" : "")} onClick={() => this.handleSelectCurrency(val.idx)}>
                    <span className="CurrencyBase">
                        {val.base}
                    </span>
                    <Typography classname="h400">
                        {val.name}
                    </Typography>
                </div>
                { idx + 1 < currenciesList.length && <Divider /> }
            </React.Fragment>
        )
        
        return (
            <React.Fragment>
                {this.state.currenciesList.default !== this.state.selectedCurrency && (
                    <React.Fragment>
                        <div key={'defaultCurrency'} className="CurrencyItem Selected" onClick={() => this.handleSelectCurrency(this.state.currenciesList.default)}>
                            <span className="CurrencyBase">{this.state.currenciesList.list[this.state.selectedCurrency].base}</span><IntlMessage id="header.currency.deactivate" />
                        </div>
                    </React.Fragment>
                )}
                {this.state.currenciesList.preferred && (
                    <React.Fragment>
                        {favoriteCurrencies.map((val, idx) => currencyComponent(val, idx) )}
                    </React.Fragment>
                )}
                {currenciesList.map((val, idx) => currencyComponent(val, idx) )}
            </React.Fragment>
        )
    }

    handleClick = (e) => {
        if (this.node){
          if ( !this.node.contains(e.target) ){
            this.setState({ displayModal: false })
          }
        }
    }

    render() {
        if(this.state.currenciesList.list.length === 1) return '';

        let CurrencyLink = '';
        if (this.props.mode === "b2b") {
            CurrencyLink = (
                <Avatar className={(this.props.className || '') + " NewCurrencySelectorButton Avatar"} onClick={() => this.handleToggleCurrencyModal()}>
                    {this.state.currenciesList.list[this.state.selectedCurrency].base}
                </Avatar>
            )
        } else {
            CurrencyLink = (
                <Avatar onClick={() => this.setState({ displayModal: true })} className={(this.props.className || '') + " NewCurrencySelectorButton Link"} >
                    <SpotlioIcon icon="fa-money" />
                </Avatar>
            )
        }

        return (
            <div ref={node => this.node = node}>
                { CurrencyLink }
                { this.state.displayModal &&
                    <div className="currencyDrop">
                        { this.handleRenderCurrenciesList() }
                    </div>
                }
            </div>
        );
    }
}
